import { combineReducers } from '@reduxjs/toolkit';
import { siteReducer, initialSiteState } from './siteProviderReducer';
import { profileReducer, initialProfileState } from './profileReducer';
import { activityReducer, initialActivityState } from './activityReducer';
import { listReducer, initialListState } from './listReducer';
import {
  companyAdminReducer,
  initialCompanyAdminState,
} from './companyAdminReducer';
import { mapReducer, initialMapState } from './mapReducer';
import { encountersReducer, initialEncountersState } from './encountersReducer';
import { drawerReducer, initialDrawerState } from './drawerSlice';
import { filterSetReducer, initialFilterSetState } from './filterSetReducer';
import {
  filterDrawerReducer,
  initialFilterDrawerState,
} from './filterDrawerReducer';
import {
  discoveryListReducer,
  initialState as initialDiscoveryListState,
} from './discoveryListReducer';
import { rolesReducer, initialRolesState } from './rolesReducer';
import {
  savedVolumesReducer,
  initialSavedVolumesState,
} from './savedVolumesReducer';

export const initialState = {
  activity: initialActivityState,
  companyAdmin: initialCompanyAdminState,
  encounters: initialEncountersState,
  lists: initialListState,
  map: initialMapState,
  profile: initialProfileState,
  siteProvider: initialSiteState,
  drawers: initialDrawerState,
  filterSets: initialFilterSetState,
  filterDrawer: initialFilterDrawerState,
  discoveryList: initialDiscoveryListState,
  roles: initialRolesState,
  savedVolumes: initialSavedVolumesState,
};

export const rootReducer = combineReducers({
  activity: activityReducer,
  companyAdmin: companyAdminReducer,
  encounters: encountersReducer,
  lists: listReducer,
  map: mapReducer,
  profile: profileReducer,
  siteProvider: siteReducer,
  drawers: drawerReducer,
  filterSets: filterSetReducer,
  filterDrawer: filterDrawerReducer,
  discoveryList: discoveryListReducer,
  roles: rolesReducer,
  savedVolumes: savedVolumesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
